import React from 'react';
import { TrendingUp, Globe, Shield } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../utils/translations';
export function WhyItMatters() {
  const {
    language
  } = useLanguage();
  const t = translations[language].whyItMatters;
  const reasons = [{
    icon: TrendingUp,
    title: t.reason1Title,
    description: t.reason1Desc,
    color: 'bg-emerald-100 text-emerald-700'
  }, {
    icon: Globe,
    title: t.reason2Title,
    description: t.reason2Desc,
    color: 'bg-blue-100 text-blue-700'
  }, {
    icon: Shield,
    title: t.reason3Title,
    description: t.reason3Desc,
    color: 'bg-orange-100 text-orange-700'
  }];
  return <section id="why-it-matters" className="py-16 sm:py-24 bg-white" data-id="element-184">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-185">
        <div className="text-center mb-16" data-id="element-186">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900" data-id="element-187">
            {t.title}
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-188">
            {t.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-189">
          {reasons.map((reason, index) => <div key={index} className="bg-gray-50 rounded-2xl p-8 border border-gray-200" data-id="element-190">
              <div className={`w-14 h-14 ${reason.color} rounded-xl flex items-center justify-center mb-6`} data-id="element-191">
                <reason.icon className="w-7 h-7" data-id="element-192" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-193">
                {reason.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-194">
                {reason.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}